import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ObjectiveItem, ObjectiveItemUpdate, ObjectiveStatus } from '~src/store/okrs/interfaces';
import { ApiReduxResp } from '~src/services/apiMiddleware';
import SelectorHandler from '~src/modules/okrs/manageObjectives/shared/SelectorHandler';
import SelectInput from '~src/shared/form/select/SelectInput';
import { statusOptions } from '~src/modules/okrs/constants/options';
import FrozenInput from '~src/shared/form/inputs/FrozenInput';

import { SplitWrapper } from './statusEdit.sc';

interface OwnProps {
  hasChangePermissions: boolean;
  objective: ObjectiveItem;
  update: (values: Partial<ObjectiveItemUpdate>) => ApiReduxResp<ObjectiveItem>;
}

type Props = OwnProps;

const StatusSection: FC<Props> = props => {
  const [t] = useTranslation();

  const statuses = useMemo(
    () =>
      statusOptions.map(option => ({
        name: t(`x.okr.objective.edit.status.${option}`),
        value: option,
      })),
    [],
  );

  const [selectedOption, setSelectedOption] = useState<ObjectiveStatus>(props.objective.status);

  const updateStatus = (val: string) => {
    props.update({ status: val as ObjectiveStatus });
    setSelectedOption(val as ObjectiveStatus);
  };

  return (
    <SelectorHandler iconName="iconPulse">
      {() => (
        <SplitWrapper>
          {props.hasChangePermissions ? (
            <SelectInput
              t={t}
              value={selectedOption}
              label={t('x.okr.objective.edit.status.label')}
              optList={statuses}
              labelKey="x.okr.objective.edit.status.label"
              onChange={updateStatus}
            />
          ) : (
            <FrozenInput
              value={selectedOption}
              label={t('x.okr.objective.edit.status.label')}
              labelKey="x.okr.objective.edit.status.label"
            />
          )}
        </SplitWrapper>
      )}
    </SelectorHandler>
  );
};

export default StatusSection;
